<template>
  <div class="modal-card spacing-px-30">
    <b-loading :isFullPage="false" :active="isLoading" />
    <span
      class="has-text-centered has-text-weight-semibold has-text-color-7 spacing-mb-20"
      >{{ App.OfficialModelsScreen.DOCUMENT_MODELS }}</span
    >
    <div class="columns mt-10">
      <b-field class="column is-8">
        <b-input
          v-model="modelSearch"
          :placeholder="General.PLACEHOLDER.TYPE_TO_SEARCH"
          type="search"
          icon="magnify"
          iconClickable
        />
      </b-field>
      <div class="column">
        <b-field
          :label="General.DOCUMENT_TYPE"
          labelPosition="on-border"
          class="select-field"
        >
          <b-select
            v-model="typeSearch"
            :disabled="Boolean(defaultDocumentType)"
            :placeholder="General.SELECT_TYPE"
            expanded
          >
            <option :value="{}" aria-role="listitem">{{ General.ALL }}</option>
            <option
              v-for="option in getValidFileTypes"
              :key="option.id"
              :value="option"
            >
              {{ option.type }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="list-model">
      <span
        class="has-text-weight-semibold has-text-color-8 bb-custom is-flex"
        >{{ General.NAME }}</span
      >
      <div v-if="Object.entries(modelList).length && !isLoading">
        <div v-for="group in Object.entries(modelList)" :key="group[0]">
          <span
            class="has-text-weight-semibold has-text-color-8 mt-5 bb-custom is-flex"
            >{{ group[0] }}</span
          >
          <template v-for="model in group[1]">
            <span
              :key="model.id"
              class="model-item bb-custom"
              @click="selectModel(model)"
            >
              <b-icon
                class="spacing-mr-10"
                :type="isContrast ? 'is-white' : 'is-primary'"
                icon="file-document"
                size="is-small"
              />
              <span class="has-text-color-8">{{ model.name }}</span>
            </span>
          </template>
        </div>
      </div>
      <div v-else id="models-empty" class="has-text-color-7">
        {{ General.TEXTS.NO_MODELS }}
      </div>
    </div>
    <div class="mt-20 is-flex is-justify-content-flex-end">
      <b-button
        :type="isContrast ? 'is-white' : 'is-primary'"
        outlined
        @click="close"
      >
        {{ General.CANCEL.toUpperCase() }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { App, General } from "@/utils/constants";
import debounce from "lodash/debounce";

export default {
  name: "ModalOfficialModels",
  components: {},

  props: {
    processId: {
      type: String,
      default: ""
    },
    defaultDocumentType: {
      type: String,
      default: ""
    },
    onSelect: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      modelSearch: "",
      isLoading: false,
      typeSearch: {}
    };
  },

  computed: {
    ...mapGetters({
      getFileTypes: "getFileTypes",
      getAllModels: "getEdowebDocument",
      getModelsByTypeFiltered: "getModelsByTypeFiltered",
      isContrast: "isContrast"
    }),

    getValidFileTypes() {
      return this.getFileTypes.map(actual => ({
        id: actual.id,
        type: actual.type
      }));
    },

    modelList() {
      return this.getAllModels.list.reduce((acc, actual) => {
        if (acc[actual.document_type]) acc[actual.document_type].push(actual);
        else acc[actual.document_type] = [actual];
        return acc;
      }, {});
    }
  },

  watch: {
    typeSearch: {
      handler() {
        this.getEdowebList();
      }
    },
    modelSearch: {
      handler() {
        this.getEdowebList();
      }
    }
  },

  async beforeMount() {
    this.isLoading = true;
    this.fileTypesRequest({ state: true, to_publish: true });
    await this.getEdowebList();
    this.isLoading = false;
  },

  methods: {
    ...mapActions({
      copyGdocDocumentRequest: "copyGdocDocumentRequest",
      getAllModelList: "getAllModelList",
      fileTypesRequest: "fileTypesRequest",
      getModelsListByTypeRequest: "getModelsListByTypeRequest",
      getDocumentEdoweb: "listModelDocumentEdoweb"
    }),

    setInitialType() {
      if (this.getFileTypes.length && this.defaultDocumentType) {
        this.typeSearch = this.getFileTypes.find(fileType => {
          return fileType.id == this.defaultDocumentType;
        });
      }
    },

    getEdowebList: debounce(async function() {
      this.isLoading = true;
      await this.getDocumentEdoweb({
        page: 1,
        paginator_count: 20,
        search: this.modelSearch,
        document_type:
          this.typeSearch?.type && JSON.stringify([this.typeSearch.type])
      });
      this.isLoading = false;
    }, 500),

    async selectModel(model) {
      this.onSelect(model);
      this.close();
    },

    close() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  padding: 15px;

  background-color: $color-1;
}
.list-container {
  overflow: auto;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.list-model {
  overflow: auto;

  #models-empty {
    text-align: center;
    margin: 10px 0;
  }
}

.model-item {
  display: flex;
  align-items: center;
  padding: 5px;
  margin-top: 5px;
  cursor: pointer;
  &:hover {
    background-color: $color-2;
  }
}

.bb-custom {
  border-bottom: 1px solid #f2f2f2;
}

.custom-self-align-end {
  align-self: flex-end;
}

.label-custom {
  z-index: 1;
  position: absolute;
  font-size: 0.75rem;
  background: white;
}
</style>
